import config from "./config";

function http(url, method, data, stringify = true) {
  let headers = { Accept: "application/json" };
  let token = localStorage.getItem("bt:accessTokenAdmin");

  headers = { ...headers, Authorization: "Bearer " + (token || "none") };

  if (stringify) {
    headers = { ...headers, "Content-Type": "application/json" };
  }
  return fetch(`${config.apiUrl}/${url}`, {
    method: method,
    headers,
    body: stringify ? JSON.stringify(data) : data
  })
    .then(response => {
      if (response.status === 401 || response.error === 401) {
        document.location.href = window.location.protocol + "//" + window.location.host + "/management/login";
      }
      if (response.ok) {
        return response.json();
      }
      return response;
    })
    .catch(err => {
      if (err.status === 401 || err.error === 401) {
        document.location.href = window.location.protocol + "//" + window.location.host + "/management/login";
      }
      return { error: err };
    });
}

function httpAsResponse(url, method, data, stringify = true) {
  let headers = { Accept: "application/json" };
  const token = localStorage.getItem("bt:accessTokenAdmin");

  headers = { ...headers, Authorization: "Bearer " + (token || "none") };

  if (stringify) {
    headers = { ...headers, "Content-Type": "application/json" };
  }
  return fetch(`${config.apiUrl}/${url}`, {
    method: method,
    headers,
    body: stringify ? JSON.stringify(data) : data
  });
}

function auth(url, method, data, stringify = true) {
  let headers = { Accept: "application/json" };
  let token = localStorage.getItem("bt:accessTokenAdmin");

  if (token) {
    headers = { ...headers, Authorization: "Bearer " + token };
  }
  if (stringify) {
    headers = { ...headers, "Content-Type": "application/json" };
  }
  return fetch(`${config.apiUrl}/api/auth/v2${url}`, {
    method: method,
    headers,
    body: stringify ? JSON.stringify(data) : data
  })
    .then(response => response.json())
    .catch(err => {
      return { error: err };
    });
}

export { auth, http, httpAsResponse };
